angular.module('impactx.MenuDirectives').directive('ixShutdownInfo', function () {
    return {
        restrict: 'E',
        templateUrl: 'shared/menu/templates/shutdown-info.tmpl.html',
        controller: "ShutDownInfoCtrl",
        controllerAs: "shutdownInfoCtrl"
    }
});